module.exports = __webpack_public_path__ + "static/media/banner2.ffd82126.jpg";